import { useState, useEffect } from 'react';
import { API_ENDPOINTS, MARKET_MAPPING, INTEGRATION_TYPES } from '../constants';

const determineIntegrationType = (apiUrl, apiUserName) => {
    if (apiUrl?.toLowerCase().includes('flex')) return INTEGRATION_TYPES.GAMEFLEX;
    if (apiUrl?.toLowerCase().includes('ogs')) return INTEGRATION_TYPES.OGS;
    if (apiUserName?.startsWith('L0') || apiUserName?.startsWith('P0')) return INTEGRATION_TYPES.GAMEFLEX;
    return INTEGRATION_TYPES.GGI;
};

const useServerExplorer = () => {
    const [servers, setServers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [marketList, setMarketList] = useState([]);
    const [selectedMarket, setSelectedMarket] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchServers = async () => {
            try {
                const response = await fetch(API_ENDPOINTS.SERVER_DATA);
                const data = await response.json();

                const mappedServers = data.map((server) => ({
                    serverId: server.ServerID,
                    serverName: server.ServerName,
                    operatorID: server.OperatorID,
                    regulatedMarketShort: server.CasinoSiteID,
                    brandName: server.LobbyName,
                    environment: determineIntegrationType(server.APIUrl, server.APIUserName),
                }));

                setServers(mappedServers);

                const uniqueMarkets = [...new Set(mappedServers.map((server) => server.regulatedMarketShort))];
                setMarketList(uniqueMarkets.map((market) => ({ label: market })));
                setLoading(false);
            } catch (error) {
                console.error('Error fetching server data:', error);
                setError('Failed to fetch server data');
                setLoading(false);
            }
        };

        fetchServers();
    }, []);

    const filteredServers = servers.filter((server) => {
        const matchesSearch =
            server.serverId.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            server.serverName.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesMarket = selectedMarket ? server.regulatedMarketShort === selectedMarket.label : true;

        return matchesSearch && matchesMarket;
    });

    const processServerSelection = (server) => {
        if (!server) {
            console.error("Server data is undefined");
            return null;
        }

        try {
            const site = server.regulatedMarketShort || "Unknown Site";
            const market = MARKET_MAPPING[site] || "Unknown Market";

            return {
                serverId: server.serverId || "",
                serverName: server.serverName || "Unknown Server",
                lobbyName: server.brandName || "Unknown Lobby",
                site,
                market,
                environment: server.environment || "Unknown Integration",
            };
        } catch (error) {
            console.error("Error processing server data:", error);
            return null;
        }
    };

    return {
        servers: filteredServers,
        marketList,
        searchTerm,
        selectedMarket,
        loading,
        error,
        setSearchTerm,
        setSelectedMarket,
        processServerSelection
    };
};

export default useServerExplorer;